import React, { useState } from 'react';
import { GridColumn, GridRow } from 'app/member/layouts/grid';
import { Spacer } from 'app/layouts/generic';
import { Button } from 'app/shared/button';
import { DetailItem } from 'app/shared/info-section/item';
import { SimpleInput } from 'app/shared/input';
import { MultiSelect } from 'app/shared/select';
import { useIssueService } from 'hooks/api/agents/issue';
import { CATEGORY_OPTIONS, SEVERITY_OPTIONS } from '../constants';
import styles from '../issues.module.css';
import Wysiwyg from 'app/shared/input/wysiwyg';

const INITIAL_FORM = {
  title: '',
  description: '',
  category: 'other',
  severity: 'medium',
  jira_key: '',
  jira_url: ''
};

export const CreateIssueForm = ({ onCreated = () => {}, closeModal = () => {} }) => {
  const { createIssue } = useIssueService();
  const [form_data, setFormData] = useState(INITIAL_FORM);
  const [submitting, setSubmitting] = useState(false);

  const set = (field, value) => setFormData((prev) => ({ ...prev, [field]: value }));

  const form_is_valid = form_data.title.trim() !== '';

  const handleSubmit = async () => {
    if (!form_is_valid) return;
    setSubmitting(true);
    const { issue } = await createIssue({
      title: form_data.title.trim(),
      description: form_data.description.trim() || null,
      category: form_data.category,
      severity: form_data.severity,
      jira_key: form_data.jira_key.trim() || null,
      jira_url: form_data.jira_url.trim() || null
    });
    setSubmitting(false);
    if (issue && (issue.id || issue._id)) {
      onCreated(issue);
      setFormData(INITIAL_FORM);
      closeModal();
    }
  };

  return (
    <div className={styles.form}>
      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Title" required>
            <SimpleInput
              value={form_data.title}
              onInput={(value) => set('title', value)}
              placeholder="Emails stuck in queue"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={1}>
        <GridColumn>
          <DetailItem title="Description">
            <Wysiwyg
              rows={3}
              value={form_data.description}
              onInput={(value) => set('description', value)}
              placeholder="What is happening?"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="Category">
            <MultiSelect
              options={CATEGORY_OPTIONS}
              value={CATEGORY_OPTIONS.find((o) => o.value === form_data.category)}
              onChange={(option) => set('category', option.value)}
              isMulti={false}
              isClearable={false}
              menuPortalTarget={document.body}
            />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Severity">
            <MultiSelect
              options={SEVERITY_OPTIONS}
              value={SEVERITY_OPTIONS.find((o) => o.value === form_data.severity)}
              onChange={(option) => set('severity', option.value)}
              isMulti={false}
              isClearable={false}
              menuPortalTarget={document.body}
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={2} />

      <GridRow num_of_columns={2}>
        <GridColumn>
          <DetailItem title="Jira key">
            <SimpleInput
              value={form_data.jira_key}
              onInput={(value) => set('jira_key', value)}
              placeholder="SUP-123"
            />
          </DetailItem>
        </GridColumn>
        <GridColumn>
          <DetailItem title="Jira URL">
            <SimpleInput
              value={form_data.jira_url}
              onInput={(value) => set('jira_url', value)}
              placeholder="https://org.atlassian.net/browse/SUP-123"
            />
          </DetailItem>
        </GridColumn>
      </GridRow>

      <Spacer multiple={3} />

      <div className={styles.dialogActions}>
        <Button text="Cancel" type="secondary" onClick={closeModal} />
        <Button
          text="Create Issue"
          onClick={handleSubmit}
          disabled={!form_is_valid}
          loading={submitting}
        />
      </div>
    </div>
  );
};

export default CreateIssueForm;
